import {readonly,ref} from "vue";

export function useCookieMessage() {

    const shouldShowBanner = ref(false);
    const timestamp = localStorage.getItem('cookie');
    const expiryDate = 1000 * 60 * 60 * 24 * 30;

    if (timestamp === null || parseInt(timestamp) + expiryDate < Date.now()) {
        shouldShowBanner.value = true;
    }

    const hideBanner = () => {
        shouldShowBanner.value = false;
        localStorage.setItem('cookie', Date.now());
    };

    return {
        shouldShowBanner: readonly(shouldShowBanner),
        hideBanner
    }
}